/* CUSTOM_PRODUCTRULES_BY_CLAUDE (Ryan 2026-10-11, Product Rules Session 10) - FILL THE VENDOR GUIDE FROM TEXT.
   Planner: Team-Portal-Bot/tools/Product-Rules/CUSTOM-PRODUCT-RULES-PLANNER.md (Session 10).

   Vendor Guide -> Admin Mode -> "Fill from text". Ryan writes (or pastes) what he knows about a supplier in his own
   words; rfq-worker's POST /vendor-guide/vendor/draft has Claude read it against the record on file (and any supplier
   he names: "same as Legend, except...") and answers with what it understood, the plain questions it still has, and
   the Guide's own preview of the change (summary + field-by-field before / after). He answers the questions in the
   box and reads it again, as many times as he likes. Save is POST /vendor-guide/vendor/apply, pinned to the record
   the preview read, so an edit somebody made in between is never overwritten.

   ⛔ NOTHING IS SAVED BEFORE "SAVE". ⛔ ADMINS ONLY (the worker refuses anybody else; this panel sits in Admin Mode).
   Classic script (no modules): the theme CDN rewrites dynamic import(). Reads the screen through
   window.VendorGuideHooks (custom-vendor-guide.js). */
(function () {
  'use strict';

  var RFQ_WORKER_URL = 'https://rfq-worker.ryan-29b.workers.dev';
  var TEXT_MAX = 12000;
  var NEW = '__new__';

  var st = { vendorId: NEW, convo: '', busy: false, result: null, error: '', saved: null };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /** A diff value as a person reads it. Pure. */
  function showValue(v) {
    if (v === null || v === undefined || v === '') return '(empty)';
    if (Array.isArray(v)) return v.length ? v.join(', ') : '(empty)';
    if (v === true) return 'yes';
    if (v === false) return 'no';
    return String(v);
  }

  /** The conversation after Ryan answers the questions: the answers ride under what he already wrote. Pure. */
  function conversationWith(convo, answers) {
    var a = String(answers || '').trim();
    if (!a) return String(convo || '');
    return String(convo || '').trim() + '\n\nMy answers to your questions:\n' + a;
  }

  /** The apply body for a draft result. Pure. */
  function applyBody(result, vendorId) {
    var create = vendorId === NEW;
    var body = create ? { create: true } : { id: vendorId };
    body.patch = result.patch;
    body.basedOn = result.preview.basedOn;
    if (result.preview.clearsRequired && result.preview.clearsRequired.length) body.clears = result.preview.clearsRequired.slice();
    body.note = 'Filled from text on the Vendor Guide screen';
    return body;
  }

  /** What the Save button says. Pure. */
  function saveLabel(result) {
    var n = (result && result.questions && result.questions.length) || 0;
    return n ? 'Save what is here (' + n + ' question' + (n === 1 ? '' : 's') + ' still open)' : 'Save to the Vendor Guide';
  }

  function canSave(result) {
    return !!(result && result.preview && result.preview.fieldCount > 0 && !result.previewError);
  }

  function hooks() { return window.VendorGuideHooks || null; }

  function token() {
    var s = window.RepPortal && window.RepPortal.Auth && window.RepPortal.Auth.getSession && window.RepPortal.Auth.getSession();
    return s && s.accessToken;
  }

  function post(path, body) {
    var t = token();
    if (!t) return Promise.resolve({ ok: false, status: 401, data: { error: 'You are signed out. Sign in again.' } });
    return fetch(RFQ_WORKER_URL + path, {
      method: 'POST',
      headers: { Authorization: 'Bearer ' + t, 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
    }).catch(function (err) { return { ok: false, status: 0, data: { error: (err && err.message) || 'network error' } }; });
  }

  function vendorOptions() {
    var h = hooks();
    var list = (h ? h.vendors() : []).filter(function (v) { return v && !v.defunct; }).slice();
    list.sort(function (a, b) { return String(a.name).localeCompare(String(b.name)); });
    return list;
  }

  function vendorName(id) {
    var v = vendorOptions().filter(function (x) { return x.id === id; })[0];
    return v ? v.name : '';
  }

  function previewHtml(r) {
    var out = '';
    if (r.previewError) {
      var e = r.previewError;
      var extra = e.missing && e.missing.length ? ' Still needed before a new supplier can be saved: ' + e.missing.map(function (m) {
        return m === 'po.shortCode' ? 'a short code' : (m === 'po.workflow' ? 'how orders are placed' : (m === 'name' ? 'the name' : m));
      }).join(', ') + '.' : '';
      if (e.collisions && e.collisions.length) extra += ' A supplier like this already exists: ' + e.collisions.map(function (c) { return c.name || c.id; }).join(', ') + '. Pick it from the list instead.';
      /* A missing field is said in words; the Guide's own error names field paths, so it is shown only when there are none. */
      out += '<p class="vg-fill__msg vg-fill__msg--err">The Guide would not take this yet.' + (extra ? esc(extra) : ' ' + esc(e.error) + '.') + '</p>';
      return out;
    }
    if (!r.preview) {
      out += '<p class="vg-fill__msg">Nothing to change yet.</p>';
      return out;
    }
    if (!r.preview.fieldCount) {
      out += '<p class="vg-fill__msg">No change: the Guide already says this.</p>';
      return out;
    }
    out += '<p class="vg-fill__label">What Save would change</p>';
    out += '<p class="vg-fill__summary">' + esc(r.preview.summary) + '</p>';
    out += '<table class="vg-fill__diff"><thead><tr><th>Field</th><th>Now</th><th>After Save</th></tr></thead><tbody>';
    r.preview.diff.forEach(function (d) {
      out += '<tr><td>' + esc(d.label || d.field) + '</td><td>' + esc(showValue(d.before)) + '</td><td>' + esc(showValue(d.after)) + '</td></tr>';
    });
    out += '</tbody></table>';
    if (r.preview.clearsRequired && r.preview.clearsRequired.length) {
      out += '<p class="vg-fill__msg vg-fill__msg--warn">This empties ' + r.preview.clearsRequired.length + ' field' + (r.preview.clearsRequired.length === 1 ? '' : 's') + ' that has a value. Check the "After Save" column before you save.</p>';
    }
    return out;
  }

  function render() {
    var body = document.querySelector('[data-vg-fill-body]');
    if (!body) return;
    var r = st.result;
    var started = !!r || !!st.saved;
    var html = '';
    var opts = '<option value="' + NEW + '"' + (st.vendorId === NEW ? ' selected' : '') + '>New supplier</option>';
    vendorOptions().forEach(function (v) {
      opts += '<option value="' + esc(v.id) + '"' + (st.vendorId === v.id ? ' selected' : '') + '>' + esc(v.name) + '</option>';
    });
    html += '<div class="vg-fill__row"><label class="vg-fill__label" for="vg-fill-vendor">Supplier</label>' +
      '<select id="vg-fill-vendor" class="vg-fill__select" data-vg-fill-vendor' + (started ? ' disabled' : '') + '>' + opts + '</select>' +
      (started ? '<button type="button" class="vg-btn vg-btn--ghost" data-vg-fill-reset>Start over</button>' : '') + '</div>';

    if (st.saved) {
      html += '<p class="vg-fill__msg vg-fill__msg--ok">Saved to ' + esc(st.saved.name) + '. ' + esc(st.saved.summary || '') + '</p>';
      body.innerHTML = html;
      return;
    }

    if (!r) {
      html += '<textarea class="vg-form__textarea vg-fill__text" data-vg-fill-text rows="6" maxlength="' + TEXT_MAX + '" placeholder="For example: New vendor, they have a dealer portal at https://... and we don\'t have payment terms with them yet. They ship out of their Colorado location. Otherwise same as Legend.">' + esc(st.convo) + '</textarea>';
      html += '<div class="vg-fill__row"><button type="button" class="vg-btn vg-btn--primary" data-vg-fill-read' + (st.busy ? ' disabled' : '') + '>' + (st.busy ? 'Reading…' : 'Read it') + '</button></div>';
    } else {
      html += '<p class="vg-fill__label">What you wrote</p><p class="vg-fill__said">' + esc(st.convo) + '</p>';
      if (r.understood) html += '<p class="vg-fill__label">What I took from it</p><p class="vg-fill__summary">' + esc(r.understood) + '</p>';
      if (r.readAlongside && r.readAlongside.length) html += '<p class="vg-fill__msg">Read alongside: ' + esc(r.readAlongside.join(', ')) + '.</p>';
      html += previewHtml(r);
      if (r.dropped && r.dropped.length) {
        html += '<p class="vg-fill__msg vg-fill__msg--warn">Left out: ' + esc(r.dropped.map(function (d) { return d.path + ' (' + d.why + ')'; }).join('; ')) + '.</p>';
      }
      if (r.questions && r.questions.length) {
        html += '<p class="vg-fill__label">Questions</p><ol class="vg-fill__questions">' + r.questions.map(function (q) { return '<li>' + esc(q) + '</li>'; }).join('') + '</ol>';
      }
      html += '<textarea class="vg-form__textarea vg-fill__text" data-vg-fill-answer rows="3" placeholder="' + (r.questions && r.questions.length ? 'Answer the questions, or add anything else' : 'Add or correct anything') + '"></textarea>';
      html += '<div class="vg-fill__row">' +
        '<button type="button" class="vg-btn vg-btn--ghost" data-vg-fill-again' + (st.busy ? ' disabled' : '') + '>' + (st.busy ? 'Reading…' : 'Read it again') + '</button>' +
        (canSave(r) ? '<button type="button" class="vg-btn vg-btn--primary" data-vg-fill-save' + (st.busy ? ' disabled' : '') + '>' + esc(saveLabel(r)) + '</button>' : '') +
        '</div>';
    }
    if (st.error) html += '<p class="vg-fill__msg vg-fill__msg--err">' + esc(st.error) + '</p>';
    body.innerHTML = html;
  }

  function read(text) {
    var t = String(text || '').trim();
    if (!t) { st.error = 'Write what you know about the supplier first.'; render(); return; }
    if (t.length > TEXT_MAX) { st.error = 'That is longer than ' + TEXT_MAX + ' characters. Trim it and try again.'; render(); return; }
    st.busy = true; st.error = ''; st.convo = t; render();
    var body = st.vendorId === NEW ? { create: true, text: t } : { id: st.vendorId, text: t };
    post('/vendor-guide/vendor/draft', body).then(function (res) {
      st.busy = false;
      if (!res.ok) { st.error = (res.data && res.data.error) || ('Could not read it (HTTP ' + res.status + ').'); render(); return; }
      st.result = res.data;
      render();
    });
  }

  function save() {
    var r = st.result;
    if (!canSave(r)) return;
    st.busy = true; st.error = ''; render();
    post('/vendor-guide/vendor/apply', applyBody(r, st.vendorId)).then(function (res) {
      st.busy = false;
      if (!res.ok) {
        st.error = res.status === 409
          ? 'Somebody changed this supplier since the preview, so nothing was saved. Press "Read it again" to see the change against what is there now.'
          : 'Not saved: ' + ((res.data && res.data.error) || ('HTTP ' + res.status));
        render();
        return;
      }
      var v = (res.data && res.data.vendor) || {};
      st.saved = { name: v.name || vendorName(st.vendorId), summary: res.data.summary || '' };
      if (v.id) st.vendorId = v.id;
      st.result = null;
      render();
      var h = hooks();
      if (h && h.reload) { try { h.reload(); } catch (e) { /* the list refreshes on the next load */ } }
    });
  }

  function reset() { st = { vendorId: NEW, convo: '', busy: false, result: null, error: '', saved: null }; render(); }

  function toggle(btn) {
    var panel = document.querySelector('[data-vg-fill]');
    if (!panel) return;
    var open = panel.hidden;
    if (open) render(); // fill it first, so the slide opens to its real height
    if (window.VGSlide) window.VGSlide(panel, open); else panel.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-vg-fill-toggle]');
    if (b) { toggle(b); return; }
    if (t.closest('[data-vg-fill-read]')) { var ta = document.querySelector('[data-vg-fill-text]'); read(ta ? ta.value : ''); return; }
    if (t.closest('[data-vg-fill-again]')) { var an = document.querySelector('[data-vg-fill-answer]'); read(conversationWith(st.convo, an ? an.value : '')); return; }
    if (t.closest('[data-vg-fill-save]')) { save(); return; }
    if (t.closest('[data-vg-fill-reset]')) { reset(); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-vg-fill-vendor]')) { st.vendorId = t.value; st.error = ''; }
  });

  /* For tests (tests/vendor-guide-fill-tests.mjs). */
  window.VendorGuideFill = { showValue: showValue, conversationWith: conversationWith, applyBody: applyBody, saveLabel: saveLabel, canSave: canSave, NEW: NEW };
})();
/* END CUSTOM_PRODUCTRULES_BY_CLAUDE */
